import React from 'react';
import { Card, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

function SimpleDetailed(props) {
    const { t, i18n } = useTranslation();

    const { 
      inputParam_Item = null,
      inputParam_ItemFields = null,
    } = props;

    return (
              <Row className="justify-content-end">
              {
                inputParam_Item.l_vals.map((val, indexVal) => (
                  <fieldset key={indexVal} className="border-bottom">
                    <div className="p-0 m-0 d-flex">
                      {
                        inputParam_ItemFields && inputParam_ItemFields.map((_field, index) => (
                            <div key={index} className="p-0 m-0">
                              {
                                index === 0 &&
                                    <Card className="p-0 m-0 my-1 me-1">
                                      <Card.Body className='p-0 m-0 text-center rounded-top' style={{backgroundColor: "gray", color: "white", height: "20px !important"}}>
                                        { t(`data-lang-lbl-field-serieTime`) }
                                      </Card.Body>
                                      <Card.Body className={`pt-1 pb-0 rounded-bottom text-center ${_field.field.toLowerCase() === 'valuereal' ? "variable-text-color-" + val.color : "variable-value-color" } ${_field.field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color-" + val.color : "" } `}>
                                        {`${val["serieTime"] !== null ? val["serieTime"] : ""}`}
                                      </Card.Body>
                                    </Card>
                              }
                              {
                                _field.field !== "serieTime" &&
                                    <Card style={{width: '100px'}} className="p-0 m-0 my-1 me-1">
                                      <Card.Body className='p-0 m-0 text-center rounded-top' style={{backgroundColor: "gray", color: "white", height: "20px !important"}}>
                                        { t(`data-lang-lbl-field-${_field.field}`) }
                                      </Card.Body>
                                      <Card.Body className={`pt-1 pb-0 rounded-bottom text-center ${_field.field.toLowerCase() === 'valuereal' ? "variable-text-color-" + val.color : "variable-value-color" } ${_field.field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color-" + val.color : "" } `}>
                                          {`${val[_field.field] !== undefined && !isNaN(val[_field.field]) ? (val[_field.field] !== null ? (_field.field !== 'serieTime' ? parseFloat(val[_field.field]).toLocaleString(i18n.language) : val[_field.field]) + (_field.simbol !== null ? _field.simbol : ""): t('no-data')) : t('no-data')}`}
                                      </Card.Body>
                                    </Card>
                              }
                            </div>                           
                        ))   
                      }
                    </div>
                  </fieldset>
                ))   
              }
              </Row>
    );
}

SimpleDetailed.propTypes = {
  inputParam_Item: PropTypes.object.isRequired,
  inputParam_ItemFields: PropTypes.array.isRequired,
};

export default SimpleDetailed;